import { useEffect } from 'react';

/**
 * Pauses any `[data-anim3d]` element's CSS animation while it is off-screen,
 * ported from the prototype's `watch3d()`. Cheap insurance against burning a
 * laptop's fan on a decorative loop nobody is looking at.
 */
export function useAnim3d() {
  useEffect(() => {
    if (typeof window === 'undefined' || !window.IntersectionObserver) return;
    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          (entry.target as HTMLElement).style.animationPlayState = entry.isIntersecting
            ? 'running'
            : 'paused';
        }
      },
      { rootMargin: '120px' }
    );
    const els = document.querySelectorAll<HTMLElement>('[data-anim3d]');
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}
